import React, { useState } from "react";
import { Card, IconButton, Tooltip, Chip } from "@mui/material";
import { Icon } from "@iconify/react";
import CustomConfirmation from "src/components/ModalPopover/Confirmation";
import { deleteFeedback } from "src/DAL/SendFormTemplate/sendFormTemplate";
import RecordNotFound from "src/components/RecordNotFound";
import { show_proper_words } from "src/utils/constant";
import moment from "moment";
import { useContentSetting } from "src/Hooks/ContentSettingState";

const FeedBack = ({
  feedbackList,
  setFeedbackList,
  setOpenAddFeedback,
  setFeedback,
  dialogSx,
}) => {
  const { userInfo } = useContentSetting();
  const [openDelete, setOpenDelete] = useState(false);
  const [feedbackId, setFeedbackId] = useState("");

  const handleEdit = (item) => {
    setFeedback({
      feedback: item?.feedback_content,
      feedbackId: item?._id,
    });
    setOpenAddFeedback(true);
  };

  const handleDelete = (item) => {
    setFeedbackId(item?._id);
    setOpenDelete(true);
  };

  const handleDeleteConfirm = async () => {
    const result = await deleteFeedback(feedbackId);
    if (result?.code === 200) {
      setOpenDelete(false);
      setFeedbackList((prev) =>
        prev.filter((item) => item?._id !== feedbackId),
      );
    }
  };

  return (
    <div className="container-fluid px-1">
      {feedbackList.length > 0 ? (
        feedbackList.map((item, index) => (
          <Card
            key={item._id || index}
            sx={{
              boxShadow: "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px",
              borderRadius: 1.5,
              mb: 1.5,
              overflow: "visible",
            }}
          >
            {/* ── Card Header ── */}
            <div
              className="d-flex align-items-center justify-content-between px-2 pt-2 pb-1"
              style={{
                borderBottom: "1px solid #f0f0f0",
                gap: 8,
              }}
            >
              {/* Left: index + type badge */}
              <div className="d-flex align-items-center gap-2 flex-wrap">
                <span
                  style={{
                    fontWeight: 700,
                    fontSize: 13,
                    color: "var(--portal-theme-primary, #1976d2)",
                    minWidth: 20,
                  }}
                >
                  #{index + 1}
                </span>
                <Chip
                  label={show_proper_words(item.feedback_type) + " Feedback"}
                  size="small"
                  sx={{
                    fontSize: 11,
                    height: 22,
                    backgroundColor:
                      item.feedback_type === "individual"
                        ? "#e3f2fd"
                        : "#f3e5f5",
                    color:
                      item.feedback_type === "individual"
                        ? "#1565c0"
                        : "#6a1b9a",
                    fontWeight: 600,
                  }}
                />
              </div>

              {/* Right: meta + actions */}
              <div className="d-flex align-items-center gap-1">
                {/* Author & date */}
                <div className="text-end me-1" style={{ lineHeight: 1.3 }}>
                  <div style={{ fontSize: 11, color: "#888" }}>
                    {item.role === "coach_user" ? (
                      <>
                        Coach —{" "}
                        <span style={{ fontWeight: 600 }}>
                          {item.action_info?.first_name}{" "}
                          {item.action_info?.last_name}
                        </span>
                      </>
                    ) : (
                      "Added by Admin"
                    )}
                  </div>
                  <div style={{ fontSize: 11, color: "#aaa" }}>
                    {moment(item?.createdAt).format("DD MMM YYYY, hh:mm A")}
                  </div>
                </div>

                {(item?.action_info?._id === userInfo?._id ||
                  item?.action_info?._id == userInfo?._id) && (
                  <div className="d-flex align-items-center">
                    <Tooltip title="Edit" placement="top">
                      <IconButton
                        size="small"
                        onClick={() => handleEdit(item)}
                        sx={{
                          color: "#1976d2",
                          "&:hover": { backgroundColor: "#e3f2fd" },
                        }}
                      >
                        <Icon icon="akar-icons:edit" width={16} height={16} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete" placement="top">
                      <IconButton
                        size="small"
                        onClick={() => handleDelete(item)}
                        sx={{
                          color: "#d32f2f",
                          "&:hover": { backgroundColor: "#ffebee" },
                        }}
                      >
                        <Icon
                          icon="ant-design:delete-twotone"
                          width={16}
                          height={16}
                        />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </div>
            </div>

            {/* ── Card Body: feedback content ── */}
            <div
              className="px-2 py-2"
              style={{ fontSize: 13, color: "#333", lineHeight: 1.6 }}
              dangerouslySetInnerHTML={{ __html: item?.feedback_content }}
            />
          </Card>
        ))
      ) : (
        <RecordNotFound title="Feedback" />
      )}

      <CustomConfirmation
        openDelete={openDelete}
        setOpenDelete={setOpenDelete}
        title="Are you sure you want to delete this feedback?"
        handleAgree={handleDeleteConfirm}
        sx={dialogSx}
      />
    </div>
  );
};

export default FeedBack;
